<template>
  <div style="overflow: hidden; height: 0">
    <div id="measure-vh" style="position: fixed; height: 100vh"></div>
  </div>

  <!-- Pop-up -->
  <transition name="fade">
    <div v-show="showPopUpOk" class="modal-overlayfrombottomblur" style="z-index: 999;">
      <div class="modal" style="padding: 3vh 0; min-height: 40vh; width: 70%">
        <table width="80%">
          <tr>
            <td>
              <div class="lt-blue txtc" :style="{ fontSize: fontSizeTitle + 'vh', lineHeight: fontSizeTitleLineHeight + 'vh' }">
                {{ popUpMsgTitle }}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="lt-blue txtc" :style="{ fontSize: fontSizePopUpMsg + 'vh', lineHeight: fontSizePopUpMsgLineHeight + 'vh', paddingTop: '1vh' }">
                {{ popUpMsgBody }}
              </div>
            </td>
          </tr>
          <tr v-show="!suppressOk">
            <td style="height: 10vh">
              <div style="padding-top: 2vh">
                <button class="widebtn" style="width: 50%; height: 6vh;" @click="doPopUpOk()">Ok</button>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </transition>

  <!-- Main Screen -->
  <transition name="fade">
    <div id="topdiv" class="modal-overlay-canscroll" style="width: 100%;">
<div class="modal"
     style="outline: 0.0em solid blue; display: table-cell; padding-top: 0vh; padding-bottom: 0vh; background-color: #EDF2F7; box-shadow: none;"
     :style="{ height: 98 * vhMult + 'vh' }">
        <table width="100%" style="padding: 0 2.5vh;">
          <!-- Header -->
          <tr>
            <td>
              <table width="100%" style="height: 6vh">
                <tr>
                  <td width="20%">
                    <button class="text-only-button cancel" @click="goBack()" :style="{ fontSize: fontSizeNormalInPXToUse + 'px', lineHeight: fontSizeNormalInPXLineHeightToUse + 'px' }">
                      <img class="tulogo" style="height: 1.8vh; padding-bottom: 0.3vh" alt="back" src="../assets/chevron.png"> Back
                    </button>
                  </td>
                  <td width="60%">Operations</td>
                  <td width="20%"></td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Input -->
          <tr>
            <td>
              <div style="margin: 2vh 0;">
                <label style="font-size: 12px; font-weight: bold;">Payment Session ID:</label><br>
                <input v-model="paymentSessionIdInput" type="text" placeholder="Enter Ryft Payment Session ID"
                  style="width: 100%; font-size: 12px; padding: 0.8vh; border: 1px solid #ccc; border-radius: 4px;">
              </div>
            </td>
          </tr>

          <!-- Refund Records -->
          <template v-if="fetchedRefundDataArray.length > 0">
            <tr v-for="(payment, index) in fetchedRefundDataArray" :key="payment.id">
              <td colspan="3">
                <table :style="{
                  backgroundColor: payment.status === 'refunded' ? '#eee' : '#f9f9f9',
                  marginTop: '1vh',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  fontSize: '10px',
                  borderCollapse: 'collapse',
                  opacity: payment.status === 'refunded' ? 0.6 : 1
                }" width="100%">
                  <thead>
                    <tr style="background-color: #e6e6e6;">
                      <th colspan="2" style="text-align: left; padding: 1vh 2vh;">
                        #{{ index + 1 }} — Payment ID: {{ payment.id }}
                        <input type="checkbox" v-model="payment.selectedForRefund" @change="toggleRefundCheckbox(payment)"
                          style="float: right; margin-top: 2px;" :disabled="payment.status === 'refunded'" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="padding: 0.8vh 2vh;"><strong>Recipient:</strong><br>{{ payment.recipientUserName }}<br>({{ payment.recipientId }})</td>
                      <td style="padding: 0.8vh 2vh;"><strong>Tipper:</strong><br>{{ payment.tipperDisplayname }}<br>({{ payment.tipperId }})</td>
                    </tr>
                    <tr><td style="padding: 0.8vh 2vh;">Cost</td><td style="padding: 0.8vh 2vh;">{{ payment.cost }}</td></tr>
                    <tr><td style="padding: 0.8vh 2vh;">Amount Chosen</td><td style="padding: 0.8vh 2vh;">{{ payment.amountChosen }}</td></tr>
                    <tr><td style="padding: 0.8vh 2vh;">Amount</td><td style="padding: 0.8vh 2vh;">{{ payment.amount }}</td></tr>
                    <tr><td style="padding: 0.8vh 2vh;">Total Collected Fees</td><td style="padding: 0.8vh 2vh;">{{ payment.totalCollectedFees }}</td></tr>
                    <tr><td style="padding: 0.8vh 2vh;">Ryft Real Fee</td><td style="padding: 0.8vh 2vh;">{{ payment.ryftRealFee }}</td></tr>
                    <tr><td style="padding: 0.8vh 2vh;">Status</td><td style="padding: 0.8vh 2vh;">{{ payment.status }}</td></tr>
                    <tr><td style="padding: 0.8vh 2vh;">Ryft Refund Status</td><td style="padding: 0.8vh 2vh;">{{ payment.ryftRefundStatus || 'N/A' }}</td></tr>
                    <tr><td style="padding: 0.8vh 2vh;">Ryft Refund ID</td><td style="padding: 0.8vh 2vh;">{{ payment.ryftRefundId || 'N/A' }}</td></tr>
                    <tr>
                      <td style="padding: 0.8vh 2vh;">Amount to Refund</td>
                      <td style="padding: 0.8vh 2vh;">
                        <input
                          :value="payment.amountToRefund"
                          @focus="handleFocus(payment)"
                          @input="e => handleAmountInput(payment, e)"
                          :disabled="payment.status === 'refunded'"
                          :style="{
                            width: '80px',
                            fontSize: '10px',
                            backgroundColor: payment.selectedForRefund ? '#fff' : '#ddd'
                          }"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>

            <tr>
              <td colspan="3" style="text-align: center; padding-top: 1vh;">
                <button class="widebtn" style="font-size: 10px;" @click="confirmRefunds">Refund Selected</button>
              </td>
            </tr>
          </template>

          <!-- Operation Buttons -->
          <tr>
            <td colspan="3" style="padding-top: 2vh;">
              <table width="100%" border="1" cellspacing="0" cellpadding="8" style="border-collapse: collapse; background-color: white;">
                <thead>
                  <tr style="background-color: #f0f0f0;">
                    <th style="font-size: 12px;">Operation</th>
                    <th style="font-size: 12px;">Description</th>
                    <th style="font-size: 12px;">Execute</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style="font-size: 12px;">Refund</td>
                    <td style="font-size: 9px;">Refund part or all of a tip – takes paymentSessionId</td>
                    <td><button class="widebtn" style="font-size: 10px;" @click="doRefund">Go</button></td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </transition>
</template>

<script>
const Parse = require('parse/node');
import shared from '../shared.js';

export default {
  name: 'OperationsDashboard',
  inject: ['globalPushForwardInterval', 'devEnv', 'appId', 'appJSKey'],
  props: {
    userData: shared.userDataStruct(),
  },
  data() {
    return {
      fontSizeNormal: 3.0,
      fontSizeNormalInPXToUse: '',
      fontSizeNormalLineHeight: 3.6,
      showPopUpOk: false,
      popUpMsgTitle: '',
      popUpMsgBody: '',
      suppressOk: false,
      vhMult: 1,
      paymentSessionIdInput: '',
      fetchedRefundDataArray: [],
    };
  },
  methods: {
    doFontSizeComputed() {
      this.fontSizeNormalInPXToUse = shared.convertVHSizeToMaxPixelsSize(this.fontSizeNormal, 16);
      this.fontSizeNormalInPXLineHeightToUse = shared.convertVHSizeToMaxPixelsSize(this.fontSizeNormalLineHeight, 20);
    },
    goBack() {
      this.userData.nextScreen = 'showAccountScreen';
      this.$emit('next-action', this.userData);
    },
    doPopUpOk() {
      this.showPopUpOk = false;
    },
    async fetchRefundData(paymentSessionId) {
      const result = await Parse.Cloud.run('fetchRefundData', { paymentSessionId });
      this.fetchedRefundDataArray = result.summaries.map(p => ({
        ...p,
        selectedForRefund: true,
        amountToRefund: Number(p.cost || p.amount)
      }));
    },
    doRefund() {
      if (!this.paymentSessionIdInput || !this.paymentSessionIdInput.trim()) {
        this.popUpMsgTitle = 'Missing Payment Session ID';
        this.popUpMsgBody = 'Please enter a valid payment session ID.';
        this.showPopUpOk = true;
        return;
      }
      this.fetchRefundData(this.paymentSessionIdInput.trim());
    },
    toggleRefundCheckbox(payment) {
      if (payment.selectedForRefund) {
        payment.amountToRefund = Number(payment.cost || payment.amount);
      } else {
        payment.amountToRefund = 0;
      }
    },
    handleFocus(payment) {
      if (!payment.selectedForRefund) payment.selectedForRefund = true;
    },
    handleAmountInput(payment, event) {
      let raw = event.target.value.replace(/[^0-9.]/g, '');
      const parts = raw.split('.');
      if (parts.length > 2) return;
      if (parts[1]) parts[1] = parts[1].slice(0, 2);
      const val = Number(parts.join('.'));
      const max = Number(payment.cost);
      if (!isNaN(val) && val > 0 && val <= max) {
        payment.amountToRefund = val;
        payment.selectedForRefund = true;
      }
    },
    async confirmRefunds() {
      const selected = this.fetchedRefundDataArray.filter(p => p.selectedForRefund && p.amountToRefund > 0);
      if (selected.length === 0) {
        this.popUpMsgTitle = 'No Payments Selected';
        this.popUpMsgBody = 'Select at least one payment and enter a valid refund amount.';
        this.showPopUpOk = true;
        return;
      }

      try {
        const result = await Parse.Cloud.run('doRyftRefundForPayments', {
          payments: selected.map(p => ({
            id: p.id,
            paymentSessionid: p.paymentSessionid,
            ryftSplitId: p.splitId,
            amount: p.amount,
            amountToRefund: p.amountToRefund
          }))
        });

        this.popUpMsgTitle = 'Refund Result';

        if (result.failed.length > 0) {
          this.popUpMsgBody = '✅ Success: ' + result.refunded.length + ' | ❌ Failed: ' + result.failed.length;
        } else {
          this.popUpMsgBody = '✅ Success: ' + result.refunded.length;
        }

        
        this.showPopUpOk = true;

        for (let i = 0; i < result.refunded.length; i++) {
          const ref = result.refunded[i];
          for (let j = 0; j < this.fetchedRefundDataArray.length; j++) {
            const match = this.fetchedRefundDataArray[j];
            if (match.id === ref.summary.id) {
              match.status = ref.status;
              match.amountRefunded = ref.refundedAmount;
              match.ryftRefundId = ref.ryftId;
              match.ryftRefundStatus = ref.ryftStatus;
            }
          }
        }

        for (let i = 0; i < result.failed.length; i++) {
          const fail = result.failed[i];
          for (let j = 0; j < this.fetchedRefundDataArray.length; j++) {
            const match = this.fetchedRefundDataArray[j];
            if (match.id === fail.summary.id) {
              match.ryftRefundStatus = "Failed";
              match.refundErrorMessage = fail.error;
            }
          }
        }

      } catch (err) {
        this.popUpMsgTitle = 'Refund Error';
        this.popUpMsgBody = err.message || 'Refund process failed.';
        this.showPopUpOk = true;
      }
    }
  },
  created() {
    Parse.serverURL = 'https://parseapi.back4app.com/';
    Parse.initialize(this.appId, this.appJSKey);
  },
  mounted() {
    this.doFontSizeComputed();
    this.vhMult = shared.setScreenHeightMultiplier();
  }
};
</script>
